/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createNaN } from '../../factoriesAny.js';
export var NaNDependencies = {
  BigNumberDependencies,
  createNaN
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesNaN.generated.js
// module id = 1421
// module chunks = 2